import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../pages/admin/admin_assets/css/common.css';
import axios from 'axios';
import config from '../../../config/config.js';

function MetaTags() {
  const [metaTags, setMetaTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchMetaTags = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.API_BASE_URL}/meta-tags.php`);
      const data = response.data;

      if (data.success) {
        setMetaTags(data.categories);
      } else {
        toast.error(data.message || 'Failed to fetch meta tags.');
      }
    } catch (error) {
      toast.error('An error occurred while fetching meta tags.');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id) => {
    navigate(`/admin/meta-tags/${id}`);
  };

  useEffect(() => {
    fetchMetaTags();
  }, []);

  return (
    <>
      <div className="container-fluid category_form_sec">
        <div className="category_input_wrapper mt-5">
          <div className="mb-3" style={{ width: '33%' }}>
            <h1 className="dashboard_heading">Meta Tags</h1>
          </div>
        </div>
        <div className="table-container px-0">
          {loading ? (
            <p>Loading meta tags...</p>
          ) : (
            <form>
              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Page</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {metaTags.length > 0 ? (
                    metaTags.map((tag, index) => (
                      <tr key={tag.id || index}>
                        <td>{tag.id}</td>
                        <td>{tag.page}</td>
                        <td>
                          <div className="action_btn">
                            <div
                              className="edit-btn"
                              style={{ marginRight: '20px', color: '#0d6efd', cursor: 'pointer' }}
                              onClick={() => handleEdit(tag.id)} 
                            >
                              Edit
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No meta tags available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </form>
          )}
        </div>

        <ToastContainer />
      </div>
    </>
  );
}

export default MetaTags;
